<div class="spinner-container no-bg">
  <mat-spinner class="spiner"></mat-spinner>
</div>
